import { schema } from 'normalizr'

const agentPreference = new schema.Entity('agentPreferences')
export const agentPreferencesNormalizationSchema = {
  agentPreferences: {
    nodes: [agentPreference],
  },
}
